import { render, staticRenderFns } from "./allowHalf-editor.vue?vue&type=template&id=53f076a6&scoped=true"
import script from "./allowHalf-editor.vue?vue&type=script&lang=js"
export * from "./allowHalf-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f076a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f076a6')) {
      api.createRecord('53f076a6', component.options)
    } else {
      api.reload('53f076a6', component.options)
    }
    module.hot.accept("./allowHalf-editor.vue?vue&type=template&id=53f076a6&scoped=true", function () {
      api.rerender('53f076a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-rate/allowHalf-editor.vue"
export default component.exports